import * as Types from '../../@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateTrialModeAppAnnouncementBarMutationVariables = Types.Exact<{
  imageUrl: Types.Scalars['String']['input'];
  appAnnouncementBarId: Types.Scalars['Int']['input'];
  navigationType: Types.Scalars['String']['input'];
  navigationUrl: Types.Scalars['String']['input'];
  publishTime: Types.Scalars['DateTime']['input'];
  stopTime: Types.Scalars['DateTime']['input'];
  markets: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;


export type UpdateTrialModeAppAnnouncementBarMutation = { __typename?: 'Mutation', updateTrialModeAppAnnouncementBar: { __typename?: 'Payload', count: number, error?: Types.Error | null } };


export const UpdateTrialModeAppAnnouncementBarDocument = gql`
    mutation UpdateTrialModeAppAnnouncementBar($imageUrl: String!, $appAnnouncementBarId: Int!, $navigationType: String!, $navigationUrl: String!, $publishTime: DateTime!, $stopTime: DateTime!, $markets: [String!]!) {
  updateTrialModeAppAnnouncementBar(
    parameter: {imageUrl: $imageUrl, appAnnouncementBarId: $appAnnouncementBarId, navigationType: $navigationType, navigationUrl: $navigationUrl, publishTime: $publishTime, stopTime: $stopTime, markets: $markets}
  ) {
    count
    error
  }
}
    `;
export type UpdateTrialModeAppAnnouncementBarMutationFn = Apollo.MutationFunction<UpdateTrialModeAppAnnouncementBarMutation, UpdateTrialModeAppAnnouncementBarMutationVariables>;

/**
 * __useUpdateTrialModeAppAnnouncementBarMutation__
 *
 * To run a mutation, you first call `useUpdateTrialModeAppAnnouncementBarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrialModeAppAnnouncementBarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrialModeAppAnnouncementBarMutation, { data, loading, error }] = useUpdateTrialModeAppAnnouncementBarMutation({
 *   variables: {
 *      imageUrl: // value for 'imageUrl'
 *      appAnnouncementBarId: // value for 'appAnnouncementBarId'
 *      navigationType: // value for 'navigationType'
 *      navigationUrl: // value for 'navigationUrl'
 *      publishTime: // value for 'publishTime'
 *      stopTime: // value for 'stopTime'
 *      markets: // value for 'markets'
 *   },
 * });
 */
export function useUpdateTrialModeAppAnnouncementBarMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrialModeAppAnnouncementBarMutation, UpdateTrialModeAppAnnouncementBarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrialModeAppAnnouncementBarMutation, UpdateTrialModeAppAnnouncementBarMutationVariables>(UpdateTrialModeAppAnnouncementBarDocument, options);
      }
export type UpdateTrialModeAppAnnouncementBarMutationHookResult = ReturnType<typeof useUpdateTrialModeAppAnnouncementBarMutation>;
export type UpdateTrialModeAppAnnouncementBarMutationResult = Apollo.MutationResult<UpdateTrialModeAppAnnouncementBarMutation>;
export type UpdateTrialModeAppAnnouncementBarMutationOptions = Apollo.BaseMutationOptions<UpdateTrialModeAppAnnouncementBarMutation, UpdateTrialModeAppAnnouncementBarMutationVariables>;